import React from 'react';
import NotificationManager from 'react-notifications/lib/NotificationManager';
import { Link } from 'react-router-dom';
import { NewClassRequest } from '../../classes/NewClassRequest';

async function toggleArchiveStatus(
  expedient,
  isSearching,
  getExpedientList,
  getSearchOfExpedients
) {
  const request = new NewClassRequest(
    `${process.env.REACT_APP_URL_API_LARAVEL}/electronic_expedients/${expedient.id}/archived`,
    'patch',
    null,
    { archived: !expedient.is_archived }
  );
  const response = await request.executeRequest();
  if (response && response.code === 200) {
    NotificationManager.success(
      `Expediente ${expedient.is_archived ? 'desarchivado' : 'archivado'} correctamente`,
      '',
      5000
    );
    if (isSearching) {
      await getSearchOfExpedients();
    } else {
      await getExpedientList();
    }
  } else {
    NotificationManager.error(
      'Ha ocurrido un error al intentar cambiar el estado del expediente',
      '',
      5000
    );
  }
}

export const columns = (isSearching, getExpedientList, getSearchOfExpedients) => {
  return [
    {
      dataField: 'expedient_number_link',
      text: 'No. expediente',
      sort: true,
      style: { textAlign: 'center' },
      headerStyle: { textAlign: 'center' },
    },
    {
      dataField: 'judicial_partie',
      text: 'Partido Judicial',
      sort: true,
      style: { textAlign: 'center' },
      headerStyle: { textAlign: 'center' },
    },
    {
      dataField: 'court',
      text: 'Juzgado',
      sort: true,
      style: { textAlign: 'center' },
      headerStyle: { textAlign: 'center' },
    },
    {
      dataField: 'judgment_type',
      text: 'Tipo de Juicio',
      sort: true,
      style: { textAlign: 'center' },
      headerStyle: { textAlign: 'center' },
    },
    {
      dataField: 'via',
      text: 'Vía',
      sort: true,
      style: { textAlign: 'center' },
      headerStyle: { textAlign: 'center' },
    },
    {
      dataField: '',
      text: 'Acciones',
      style: { textAlign: 'center' },
      headerStyle: { textAlign: 'center' },
      formatter: (cell, row) => (
        <button
          className="btn btn-primary"
          disabled={row.logical_deleted === true}
          title={row.logical_deleted === true ? 'Tradicional' : undefined}
          onClick={() =>
            toggleArchiveStatus(row, isSearching, getExpedientList, getSearchOfExpedients)
          }
        >
          {row.is_archived ? 'Desarchivar' : 'Archivar'}
        </button>
      ),
    },
  ];
};

export const rowClasses = (row) => (row.logical_deleted === true ? 'row-logical-deleted' : '');

export const dataFake = [
  {
    expedient_number_link: <Link to={'/expedient_details/AAA/3'}>AAA/3</Link>,
    judicial_partie: 'PRIAN',
    court: 'Juzgado 11',
    judgment_type: 'ORAL',
    via: 'Jurídica',
    matery: 'Cívil',
  },
];

/**
 * Fetches a paginated list of electronic expedients from the API
 *
 * @async
 * @param {number} sizePerPage - Number of items to display per page
 * @param {number} page - Current page number
 * @param {Function} setData - State setter function for expedients data
 * @param {Function} setTotal - State setter function for total count
 * @param {boolean|null} [archived=null] - Filter expedients by archive status (true/false), or null for all
 * @returns {Promise<void>} - Doesn't return a value, but updates state via setters
 *
 * @description
 * This function fetches expedients from the API, formats them using the formattedExpedients helper,
 * and updates the component state. It handles success and error cases, displaying appropriate
 * notifications to the user. When successful, it updates the data state with the formatted
 * expedients and the total count state with the total number of records.
 */
export const getExpedientsList = async (sizePerPage, page, setData, setTotal, archived = null) => {
  let url = `${process.env.REACT_APP_URL_API_LARAVEL}/electronic_expedients/find_expedient/${sizePerPage}?page=${page}`;

  if (archived !== null) {
    url += `&archived=${archived}`;
  }

  const request = new NewClassRequest(url, 'get', null, {});

  const responseExpedients = await request.executeRequest();
  if (
    responseExpedients &&
    responseExpedients.code === 200 &&
    responseExpedients.response &&
    responseExpedients.response.electronicExpedients
  ) {
    const expedientsFormatted = formattedExpedients(
      responseExpedients.response.electronicExpedients
    );
    setData(expedientsFormatted);
    setTotal(responseExpedients.response.total);
  } else {
    if (
      responseExpedients &&
      responseExpedients.code === 404 &&
      responseExpedients.response &&
      responseExpedients.response.message
    ) {
      setData([]);
      setTotal(0);
      NotificationManager.error(responseExpedients.response.message, '', 5000);
    } else {
      setData([]);
      setTotal(0);
      NotificationManager.error(
        'Ha ocurrido un error inesperado y no fue posible traer el listado de expedientes bajo tu acceso',
        '',
        5000
      );
    }
  }
};

export const getSearchOfExpedients = async (
  search,
  sizePerPage,
  page,
  setData,
  setTotal,
  archived = null
) => {
  const archivedSearch = archived;
  let url = `${process.env.REACT_APP_URL_API_LARAVEL}/electronic_expedients/search/find_expedient/${search}/${sizePerPage}?page=${page}`;

  if (archived !== null) {
    url += `&archived=${archivedSearch}`;
  }

  const request = new NewClassRequest(url, 'get', { search: search });

  const responseExpedients = await request.executeRequest();
  if (
    responseExpedients &&
    responseExpedients.code === 200 &&
    responseExpedients.response &&
    responseExpedients.response.electronicExpedients
  ) {
    const expedientsFormatted = formattedExpedients(
      responseExpedients.response.electronicExpedients
    );
    setData(expedientsFormatted);
    setTotal(responseExpedients.response.total);
  } else {
    if (
      responseExpedients &&
      responseExpedients.code === 404 &&
      responseExpedients.response &&
      responseExpedients.response.message
    ) {
      setData([]);
      setTotal(0);
      NotificationManager.error(responseExpedients.response.message, '', 5000);
    } else {
      setData([]);
      setTotal(0);
      NotificationManager.error(
        'Ha ocurrido un error inesperado y no fue posible traer el listado de expedientes bajo tu acceso',
        '',
        5000
      );
    }
  }
};

const formattedExpedients = (expedientsList) => {
  const expedients = expedientsList.map((exp, i) => ({
    ...exp,
    expedient_number_link:
      exp.logical_deleted === true ? (
        <span className="expedient-logical-deleted" title="Expediente Tradicional">
          <i className="fas fa-ban" aria-hidden="true" /> {exp.expedient_number}{' '}
          <small>(Tradicional)</small>
        </span>
      ) : (
        <Link to={'/expedient_details/' + exp.id}>{exp.expedient_number}</Link>
      ),
    judicial_partie: exp.judicial_party || 'N/A',
    court: exp.court || 'N/A',
    judgment_type: exp.kind_judgment,
    via: exp.via,
  }));

  return expedients;
};
